// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../../../utils/Utils.bs.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function ConversationMessageArea(props) {
  var __buttons = props.buttons;
  var __attachments = props.attachments;
  var __textInputDisabled = props.textInputDisabled;
  var __onChangeTextProp = props.onChangeText;
  var maxHeight = props.maxHeight;
  var __isFocused = props.isFocused;
  var isFocused = __isFocused !== undefined ? __isFocused : false;
  var onChangeTextProp = __onChangeTextProp !== undefined ? __onChangeTextProp : (function (prim) {
        
      });
  var textInputDisabled = __textInputDisabled !== undefined ? __textInputDisabled : false;
  var attachments = __attachments !== undefined ? Caml_option.valFromOption(__attachments) : null;
  var buttons = __buttons !== undefined ? Caml_option.valFromOption(__buttons) : null;
  var fallbackRef = React.useRef(null);
  var inputRef = Core__Option.getOr(props.inputRef, fallbackRef);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("textarea", {
                      ref: Caml_option.some(function (i) {
                            Utils.React.setCurrentRef(inputRef, i);
                          }),
                      className: "w-full border border-transparent resize-none bg-white p-0.5 text-black text-lg md:text-base",
                      style: maxHeight !== undefined ? ({
                            maxHeight: maxHeight,
                            overflowY: "auto"
                          }) : ({}),
                      disabled: textInputDisabled,
                      placeholder: props.placeholder,
                      value: Core__Option.getOr(props.text, ""),
                      onKeyDown: props.onKeyDown,
                      onFocus: props.onFocus,
                      onBlur: props.onBlur,
                      onChange: (function (evt) {
                          var value = evt.target.value;
                          var element = inputRef.current;
                          if (!(element == null)) {
                            element.setAttribute("style", "height:auto");
                            var height = element.scrollHeight + 2 | 0;
                            element.setAttribute("style", "height:" + (height.toString() + "px"));
                          }
                          onChangeTextProp(value);
                        })
                    }),
                attachments,
                buttons
              ],
              className: TailwindMerge.twMerge([
                    "w-full p-1.5 leading-tight bg-white border border-zinc-300 rounded-md transition-colors duration-150 hover:cursor-text",
                    isFocused ? "border-tan-gold-light" : "hover:border-zinc-400"
                  ]),
              id: "conversation-message-area",
              onClick: (function (evt) {
                  var eventTarget = evt.target;
                  var match = inputRef.current;
                  var match$1 = eventTarget.nodeName !== "BUTTON";
                  if (!(match == null) && match$1 && !isFocused) {
                    return match.focus();
                  }
                  
                })
            });
}

var make = ConversationMessageArea;

exports.make = make;
/* Utils Not a pure module */
